<template>
  <v-app>
    <!-- <div class="sx-background-overlay"></div> -->
    <Snackbar ref="snackbar" />
    <Loading ref="loading" />
    <router-view />
  </v-app>
</template>

<script>
import Snackbar from './components/Snackbar';
import Loading from './components/Loading';
import Bus from './bus';

export default {
  name: 'App',
  components: {
    Snackbar,
    Loading
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      Bus.$on('alert', (type, message) => {
        if (type === 'success') {
          this.$refs.snackbar.showSuccess(message);
        } else if (type === 'warning')  {
          this.$refs.snackbar.showWarning(message);
        } else if (type === 'information')  {
          this.$refs.snackbar.showInformation(message);
        } 
        else {
          this.$refs.snackbar.showError(message);
        }
      });
    }
  }
}
</script>

